<template>
  <v-container class="pa-1">
    <v-layout row>
      <v-flex>
        <v-btn
          color="#FFD600"
          class="btnReport ml-2"
          :to="
            '/weserve_admin_login/control/' +
            $store.state.backOffice.province +
            '/report/hotel-service/order-report'
          "
          v-if="permission.report.hotel_service.hotel_order_report"
        >
          <v-icon>insert_drive_file</v-icon>
          <span class>Order Report</span>
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<style>
</style>

<script>
import { mapState } from "vuex";
export default {
  computed: {},
  computed: {
    ...mapState({
      permission: (state) => state.permission,
    }),
  },
};
</script>
